import { axiosInstance } from "api/axios-config/axios-config";
import {
  GetExportExcelPapersInventory,
  GetPapersInventory,
} from "api/models/request/paper-inventory/paper-inventory";
import { Pagination } from "api/models/response/pagination";
import { GetAvailableStockAmountResponse } from "api/models/response/paper-material/get-available-stock-amount-response";
import { IPaperInventoryProperties } from "mobx-stores/_models/paper-inventory/paper-inventory";

class PaperInventoryBussiness {
  readonly url = "/api/app/paper-material-inventory";
  public getPapersInventory = async (request: GetPapersInventory) => {
    try {
      var res = await axiosInstance.get<Pagination<IPaperInventoryProperties>>(
        this.url,
        {
          params: request,
        },
      );
      return res.data;
    } catch (error) {
      console.error("Fail getPapersInventory", error);
      return Promise.reject(error);
    }
  };

  public getPaperInventory = async (id: string) => {
    try {
      var res = await axiosInstance.get<IPaperInventoryProperties>(
        `${this.url}/${id}`,
      );
      return res.data;
    } catch (error) {
      console.error("Fail getPaperInventory", error);
      return Promise.reject(error);
    }
  };

  public exportExcelByRollNumber = async (
    request: GetExportExcelPapersInventory,
  ) => {
    try {
      var res = await axiosInstance.get(
        this.url + "/export-excel-by-roll-number",
        {
          params: request,
          responseType: "blob",
        },
      );

      return res.data as Blob;
    } catch (error) {
      console.error("Fail exportExcel", error);
      return Promise.reject(error);
    }
  };

  public getAvailableStockAmount = async (
    materialId: string,
    rollNumber: string,
  ) => {
    try {
      var res = await axiosInstance.get<GetAvailableStockAmountResponse>(
        this.url +
          `/available-stock-amount/${materialId}/roll-number/${rollNumber}`,
      );

      return res.data;
    } catch (error) {
      console.error("Fail getAvailableStockAmount", error);
      return Promise.reject(error);
    }
  };
}

export const paperInventoryBussiness = new PaperInventoryBussiness();
